import React, { useSyncExternalStore } from 'react';
import SiteHeader from 'react/layout/header/SiteHeader';
import { getServerSiteHeaderState, getSiteHeaderState, subscribeToSiteHeader } from 'react/layout/header/siteHeaderState';

// The header as a PHP page mounts it: the path it loaded with, plus what the
// rest of the page publishes to siteHeaderState (the netplay app's
// navigation; the notification bell reads the counters itself). The server render and the hydrating render see the empty state.
export default function LiveSiteHeader({ header }) {
	const state = useSyncExternalStore(subscribeToSiteHeader, getSiteHeaderState, getServerSiteHeaderState);
	return (
		<SiteHeader
			header={header}
			path={state.path || header.path}
			onNetplayNavigate={state.navigateNetplay}
		/>
	);
}
